import React, { useState, useEffect } from "react";
import classes from "./auditTrial.module.css";
import {
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import {
    OppositeSortArrawBtnIcons,
    SearchIcon,
    SortArrawBtnIcons,
} from "../../../Components/Icons/Icons";
import FilterButton from "../../../Components/Filters/FilterButton";
import FilterDrawer from "../../../Components/Filters/FilterDrawer";
import CheckboxFilterGroup from "../../../Components/Filters/CheckboxFilterGroup";
import DateRangeFilter from "../../../Components/Filters/DateRangeFilter";
import { CompanyNameFilter, ContactPersonFilter, CustomerIndustyFilter } from "../../../Redux/actions/filterActions";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../Components/Pagination";
import AuditTrialListItem from "./auditTrialListItem";
import { fetchAuditTrialList } from "../../../Redux/actions/auditTrialActions";
import { handleSortClick } from "../../../Utilities/commonfunctions";
import dayjs from "dayjs";

const AuditTrial = () => {
    const [search, setSearch] = useState("");
    const dispatch = useDispatch();
    const PaginationData = useSelector(
        (state) => state.paginationData.Pagination
    );
    const { rowCount, currentPage } = PaginationData || {};
    const auditTrialList = useSelector((state) => state.auditTrialDatas);
    const { loading, error, audit_trial, totalCount } = auditTrialList || {};
    const { sortBy, companiesList, contactPersons, industries } = useSelector((state) => state.filter);
    const [companyList, setCompanyList] = useState([]);
    const [userNames, setUserNames] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const [fromDate, setFromDate] = useState(dayjs().subtract(7, 'day'));
    const [toDate, setToDate] = useState(dayjs());
    const state = [{ startDate: fromDate ? dayjs(fromDate).toDate() : null, endDate: toDate ? dayjs(toDate).toDate() : null, key: 'selection' }];

    const activeCount =
        (companiesList?.length || 0) +
        (contactPersons?.length || 0) +
        (industries?.length || 0);
    const handleClearAll = () => {
        dispatch(CompanyNameFilter([]));
        dispatch(ContactPersonFilter([]));
        dispatch(CustomerIndustyFilter([]));
        setFromDate(dayjs().subtract(7, 'day'));
        setToDate(dayjs());
    };

    useEffect(() => {
        const filterArray = {
            customers: contactPersons,
            companies: companiesList,
            channel: industries,
        }
        dispatch(fetchAuditTrialList(currentPage, rowCount, search, filterArray, sortBy, state));
    }, [
        dispatch,
        currentPage,
        rowCount,
        search,
        sortBy,
        contactPersons,
        companiesList,
        fromDate,
        toDate,
        industries
    ]);

    useEffect(() => {
        if (audit_trial?.length > 0) {
            const companyList = audit_trial.map((item) => {
                return item?.companyInfo?.company_name
            })
            const userNames = audit_trial.map((item) => {
                return item?.userInfo?.name
            })
            const uniqueCompanyList = companyList.filter((value, index, self) => {
                return value !== undefined && value !== "" && self.indexOf(value) === index;
            });
            const uniqueUserNames = userNames.filter((value, index, self) => {
                return value !== undefined && value !== "" && self.indexOf(value) === index;
            })
            console.log(uniqueCompanyList, uniqueUserNames);
            setCompanyList(uniqueCompanyList);
            setUserNames(uniqueUserNames);
        }
    }, [audit_trial])


    return (
        <div>
            <div className={classes.HeaderSearchBar}>
                <TextField
                    sx={{
                        "& legend": {
                            display: "none",
                        },
                        "& fieldset": {
                            top: 0,
                        },
                    }}
                    placeholder="Search"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    className={classes.teamMemberSearch}
                    id="firstNameinput"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    size="small"
                />
                <FilterButton
                    activeCount={activeCount}
                    onClick={() => setFilterOpen(true)}
                />
            </div>
            <div className={classes.TableContainer}>
                <Table className={classes.MainTable}>
                    <TableHead>
                        <TableRow className={classes.tableHeadRow}>
                            <TableCell className={classes.tableHeadCell}>
                                <div className={classes.tableHEadercelldiv}>
                                    <span> Date & Time </span>{" "}
                                    <span onClick={() => handleSortClick(dispatch, sortBy, "createdAt")}>
                                        {sortBy?.includes("desc") && sortBy?.includes("createdAt") ? (
                                            <OppositeSortArrawBtnIcons />
                                        ) : (
                                            <SortArrawBtnIcons />
                                        )}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell className={classes.tableHeadCell}>
                                <div className={classes.tableHEadercelldiv}>
                                    <span> Customer </span>{" "}
                                    <span onClick={() => handleSortClick(dispatch, sortBy, "companyInfo.company_name")}>
                                        {sortBy?.includes("desc") && sortBy?.includes("companyInfo.company_name") ? (
                                            <OppositeSortArrawBtnIcons />
                                        ) : (
                                            <SortArrawBtnIcons />
                                        )}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell className={classes.tableHeadCell}>
                                <div className={classes.tableHEadercelldiv}>
                                    <span> Employee </span>{" "}
                                    <span onClick={() => handleSortClick(dispatch, sortBy, "userInfo.name")}>
                                        {sortBy?.includes("desc") && sortBy?.includes("userInfo.name") ? (
                                            <OppositeSortArrawBtnIcons />
                                        ) : (
                                            <SortArrawBtnIcons />
                                        )}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell className={classes.tableHeadCell} style={{ minWidth: 235 }}>
                                <span>Action</span>
                                <span onClick={() => handleSortClick(dispatch, sortBy, "action")}>
                                    {sortBy?.includes("desc") && sortBy?.includes("action") ? (
                                        <OppositeSortArrawBtnIcons />
                                    ) : (
                                        <SortArrawBtnIcons />
                                    )}
                                </span>
                            </TableCell>
                            <TableCell className={classes.tableHeadCell}>
                                <div className={classes.tableHEadercelldiv}>
                                    <span> Channel </span>{" "}
                                    <span onClick={() => handleSortClick(dispatch, sortBy, "channel")}>
                                        {sortBy?.includes("desc") && sortBy?.includes("channel") ? (
                                            <OppositeSortArrawBtnIcons />
                                        ) : (
                                            <SortArrawBtnIcons />
                                        )}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell className={classes.tableHeadCell}>
                                <div className={classes.tableHEadercelldiv}>
                                    <span> IP Address </span>{" "}
                                    {/* <FilterMenu
                                        option={Industries}
                                        name={CustomerIndustyFilter}
                                    />{" "} */}
                                    <span onClick={() => handleSortClick(dispatch, sortBy, "ip_address")}>
                                        {sortBy?.includes("desc") && sortBy?.includes("ip_address") ? (
                                            <OppositeSortArrawBtnIcons />
                                        ) : (
                                            <SortArrawBtnIcons />
                                        )}
                                    </span>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <td colSpan="9" className="text-center">
                                    Loading...
                                </td>
                            </TableRow>
                        ) : error ? (
                            <TableRow>
                                <td colSpan="9" className="text-center">
                                    {error}
                                </td>
                            </TableRow>
                        ) : audit_trial && audit_trial.length > 0 ? (
                            audit_trial.map((item, index) => (
                                <AuditTrialListItem key={index} item={item} />
                            ))
                        ) : (
                            <TableRow>
                                <td colSpan="9" className="text-center">
                                    No Data Found
                                </td>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
            <FilterDrawer
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                onClearAll={handleClearAll}
            >
                <DateRangeFilter
                    label="Date & Time"
                    fromLabel="From Date"
                    toLabel="To Date"
                    from={fromDate}
                    to={toDate}
                    onFromChange={(val) => setFromDate(val)}
                    onToChange={(val) => setToDate(val)}
                />
                <CheckboxFilterGroup
                    label="Customer"
                    options={companyList}
                    selected={companiesList}
                    action={CompanyNameFilter}
                />
                <CheckboxFilterGroup
                    label="Employee"
                    options={userNames}
                    selected={contactPersons}
                    action={ContactPersonFilter}
                />
                <CheckboxFilterGroup
                    label="Channel"
                    options={["Mobile", "Web"]}
                    selected={industries}
                    action={CustomerIndustyFilter}
                />
            </FilterDrawer>
            <Pagination total={totalCount} />
        </div>
    );
};

export default AuditTrial;
